<template>
  <div v-if="item">
    <div v-if="item.dealer">
      <h6>
        Валеделец: <span class="text-info">{{ item.dealer.full_name }} </span>
      </h6>
      <h6>
        Номер телефона: <span class="text-info">{{ item.dealer.phone }} </span>
      </h6>
      <h6>
        Название организации:
        <span class="text-info"> {{ item.dealer.llc_name }} </span>
      </h6>
      <h6>
        Юр. адрес организации:
        <span class="text-info"> {{ item.dealer.organizationa_address }} </span>
      </h6>

      <a target="_blank" :href="`/#/shops?item_dealer=${item.dealer.id}`"
        >Смотреть детали</a
      >
    </div>
    <hr />
    <fields-list :item="item" :fields="fields" />
    <div v-if="item.remaining && item.remaining.options.length" class="m-t-3">
      <p class="text-x3-b">Остатки товаров</p>
      <div class="table-full-width table-responsive">
        <paper-table
          v-show="item.remaining.options.length"
          type="hover"
          :card="cardLink"
          :cardLink="cardLink"
          :data="item.remaining.options"
          :columns="columns"
        ></paper-table>
        <h4 v-if="item.remaining.options.length === 0">Элементов не найдено</h4>
      </div>
    </div>
    <div class="save-panel">
      <button class="btn btn-sm btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>Сохранить
      </button>
    </div>
  </div>
</template>

<script>
// import PaperTable from "../../../components/PaperTable";
import PaperTable from "@/components/PaperTable";
import { cardUpdate, cardContent } from "@/plugins/functions";

export default {
  components: {
    "paper-table": PaperTable
  },
  data: () => ({
    cardLink: "shops",
    cardSetLink: "shops",
    item: null,
    fields: [
      {
        col:' col-12 col-md-12',
        key: "cost_type",
        label: "Цены",
        type: "selectlist",
        values: [
          {
            title: "Стандартные",
            value: "COST_TYPE_PRICE"
          },
          {
            title: "Дилерские",
            value: "COST_TYPE_DEALER_PRICE"
          },
          {
            title: "Супер дилерские",
            value: "COST_TYPE_SUPER_DEALER_PRICE"
          },
          {
            title: "Оптовые",
            value: "COST_TYPE_WHOLESALE_PRICE"
          },
        ]
      },
      {
        col: " col-12 col-md-12",
        key: "name",
        label: "Название",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-12",
        key: "dealer",
        label: "Владелец ",
        type: "select",
        modal: "dealer",
        selectKey: "llc_name",
      },
      {
        col: " col-12 col-md-12",
        key: "new_images",
        resultKey: "media",
        label: "Фотографии торговой точки",
        type: "imgs",
        link: "media",
        image_key: "path_small",
      },
      {
        col:' col-12 col-md-12',
        key: "visiting_days",
        label: "Дни",
        type: "daystable",
      },
      {
        col: " col-12 col-md-12",
        key: "location_id",
        label: "Адрес",
        type: "location",
      },
      {
        col: " col-12 col-md-12",
        key: "address",
        label: "Адрес",
        type: "field",
        textType: "text",
        isMultiLang: true,
      },
      {
        col: " col-12 col-md-12",
        key: "description",
        label: "Ориентир",
        type: "textarea",
        isMultiLang: true,
      },
      {
        col: " col-12 col-md-6",
        key: "lat",
        label: "Широта",
        type: "field",
        textType: "number",
      },
      {
        col: " col-12 col-md-6",
        key: "lon",
        label: "Долгота",
        type: "field",
        textType: "number",
      },
    ],
    columns: [
      {
        key: "id",
        title: "ID",
        checkbox: false,
        control: false,
        align: "left",
        timer: false,
        detail: false,
      },
      {
        key: "price",
        title: "Цена",
        checkbox: false,
        control: false,
        align: "left",
        timer: false,
        detail: false,
        full: true,
      },
      {
        key: "amount",
        title: "Кол-во",
        checkbox: false,
        control: false,
        align: "center",
        timer: false,
        detail: false,
      },
      {
        key: "display_name",
        title: "Имя",
        checkbox: false,
        control: false,
        align: "left",
        timer: false,
        detail: false,
      },
      // {
      //   key: "role",
      //   title: "Роль",
      //   object: "title",
      //   disableLink:true
      // },
  
      // {
      //   detail: false,
      //   remove: true,
      // },
    ],
  }),

  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
    if(this.item.remaining && this.item.remaining.options.length)
      this.item.remaining.options.map(e=>{
        e.amount = e.pivot.amount
        e.price = e.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      })
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,

    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      if (item && item.id) {
        this.item["media"] = [];
        setTimeout(() => {
          this.item["media"] = item["media"];
        }, 100);
      }
    },
  },
};
</script>
<style>
</style>
